import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { inr, num } from "../../lib/format";

const MatRow = ({ m, i }) => (
  <div className="panel space-y-2 p-4" data-testid={`summary-material-${i}`}>
    <div>
      <p className="font-semibold">{m.description} {m.code && <span className="mono text-xs text-muted-foreground">[{m.code}]</span>}</p>
      <p className="text-xs text-muted-foreground">{m.fabricator} ({m.fabricator_code})</p>
    </div>
    <div className="grid grid-cols-3 gap-2 text-sm">
      <div><p className="mono-label text-muted-foreground">Given</p><p className="mono font-bold">{num(m.qty_issued)} {m.uom}</p></div>
      <div><p className="mono-label text-muted-foreground">Good shirts</p><p className="mono font-bold text-brand" data-testid={`summary-material-${i}-good`}>{num(m.good_pcs)}<span className="text-xs text-muted-foreground">/{num(m.expected_pcs)}</span></p></div>
      <div><p className="mono-label text-muted-foreground">Rejected</p><p className="mono font-bold">{num(m.rejected_pcs)}</p></div>
      <div><p className="mono-label text-muted-foreground">Pending</p><p className="mono font-bold">{num(m.pending_pcs)}</p></div>
      <div><p className="mono-label text-muted-foreground">Leftover back</p><p className="mono font-bold">{num(m.leftover_returned)}</p></div>
      <div><p className="mono-label text-muted-foreground">With fabricator</p><p className={`mono font-bold ${m.fabric_balance > 0.001 ? "text-amber-600 dark:text-amber-400" : ""}`} data-testid={`summary-material-${i}-balance`}>{num(m.fabric_balance)} {m.uom}</p></div>
    </div>
    <p className="mono text-xs text-muted-foreground" data-testid={`summary-material-${i}-cost`}>Fabric {inr(m.fabric_cost || 0)} + job work {inr(m.conversion_cost || 0)}{m.cost_per_pc ? ` · ${inr(m.cost_per_pc)}/shirt` : ""}</p>
  </div>
);

export const JobSummary = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/jobs-summary").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!data) return <p className="text-muted-foreground">Loading…</p>;
  return (
    <div className="space-y-4" data-testid="jobs-summary">
      <div className="space-y-3">
        <h2 className="mono-label px-1 text-muted-foreground">By fabricator &amp; material</h2>
        {!data.by_material.length && <p className="panel p-6 text-center text-muted-foreground">No job orders yet.</p>}
        {data.by_material.map((m, i) => <MatRow key={i} m={m} i={i} />)}
      </div>
      <div className="space-y-2">
        <h2 className="mono-label px-1 text-muted-foreground">Shirts received by location</h2>
        {!data.by_location.length && <p className="panel p-6 text-center text-muted-foreground">No shirts received yet.</p>}
        {data.by_location.length > 0 && (
          <div className="panel divide-y px-4">
            {data.by_location.map((l, i) => (
              <div key={i} className="flex justify-between gap-3 py-3 text-sm" data-testid={`summary-location-${i}`}>
                <span className="min-w-0"><b>{l.location}</b><span className="block truncate text-xs text-muted-foreground">{l.description}{l.style ? ` · ${l.style}` : ""}</span></span>
                <span className="mono shrink-0 text-right font-bold">{num(l.good_pcs)}<span className="block text-xs font-normal text-muted-foreground">{num(l.rejected_pcs)} rejected</span></span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
